import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=ae8e4c44&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=ts"
export * from "./carousel.vue?vue&type=script&lang=ts"
import style0 from "./carousel.vue?vue&type=style&index=0&id=ae8e4c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8e4c44",
  null
  
)

export default component.exports